import { createContext, useContext, useMemo } from 'react';
import useCopyLink from '../hooks/useCopyLink';
import useDownloadPdf from '../hooks/useDownloadPdf';
import { jsx as _jsx } from "react/jsx-runtime";
const LinkOrPdfShareTabContext = /*#__PURE__*/createContext(null);
export const ProvideLinkOrPdfShareTabContext = ({
  tab,
  children
}) => {
  var _tab$downloadPdfProps;
  const copyLinkData = useCopyLink(tab.copyLinkProps.getCopyLink);
  const downloadPdfData = useDownloadPdf((_tab$downloadPdfProps = tab.downloadPdfProps) === null || _tab$downloadPdfProps === void 0 ? void 0 : _tab$downloadPdfProps.getPdfLink);
  const value = useMemo(() => Object.assign({}, copyLinkData, downloadPdfData), [copyLinkData, downloadPdfData]);
  return /*#__PURE__*/_jsx(LinkOrPdfShareTabContext.Provider, {
    value: value,
    children: children
  });
};
export const useLinkOrPdfShareTabContext = () => useContext(LinkOrPdfShareTabContext);